import { useId } from 'react';

/**
 * Marco compartido de "matasellos": borde perforado + anillo interior +
 * textos curvos arriba/abajo (arcos vía textPath), en el mismo lenguaje que
 * SummerSunIcon. Se extrae aparte porque el mismo marco se reutiliza para
 * cualquier sello de tipo postal — temporada, confirmación de pedido, etc.
 * El contenido central lo define cada uso vía children, dibujado en las
 * coordenadas del propio viewBox 0 0 120 120 (centro en 60,60).
 */
export default function PostalStamp({ topText, bottomText, children, className = '', color = 'var(--kraft-deep)' }) {
    const topArcId = useId();
    const bottomArcId = useId();

    return (
        <svg viewBox="0 0 120 120" className={className} fill="none" aria-hidden="true">
            {/* Borde perforado, como el filo cortado de una estampilla */}
            <circle cx="60" cy="60" r="54" stroke="var(--line)" strokeWidth="2" strokeDasharray="1.5 5" strokeLinecap="round" />
            {/* Marco interior del sello */}
            <circle cx="60" cy="60" r="46" stroke={color} strokeWidth="1.25" opacity="0.5" />

            {topText && (
                <>
                    <path id={topArcId} d="M 22,60 A 38,38 0 0 1 98,60" fill="none" />
                    <text fontSize="7.5" letterSpacing="2" fill={color} className="font-mono">
                        <textPath href={`#${topArcId}`} startOffset="50%" textAnchor="middle">
                            {topText}
                        </textPath>
                    </text>
                </>
            )}
            {bottomText && (
                // Mismo par de puntos que el arco de arriba (izquierda→derecha) pero
                // con sweep invertido para trazar la mitad inferior — así el texto
                // sigue leyéndose de corrido, no al revés.
                <>
                    <path id={bottomArcId} d="M 22,60 A 38,38 0 0 0 98,60" fill="none" />
                    <text fontSize="6.5" letterSpacing="1.5" fill={color} opacity="0.75" className="font-mono">
                        <textPath href={`#${bottomArcId}`} startOffset="50%" textAnchor="middle">
                            {bottomText}
                        </textPath>
                    </text>
                </>
            )}

            {children}
        </svg>
    );
}
